import type { ReactNode } from 'react';

export const symbol_spa: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M452-84q-69-12-136-47.5t-119.5-95Q144-286 112-370T80-565v-10q0-11 8.5-19.5T108-603h10q53 0 113 20.5T337-530q8-79 40-163.5T455-845q10-14 25-14t25 14q46 67 78 151.5T623-530q46-30 106-51.5T842-603h10q11 0 19.5 8.5T880-575v10q0 111-32 195t-84.5 143.5Q711-167 644-131.5T508-84q-11 2-28 2t-28-2Zm36-57q-11-185-108.5-281T141-542q-2 0 0 0 13 191 113 286.5T488-141q1 1-.5.5t.5-.5Zm-93-351q23 20 46.5 50t37.5 56q14-26 38.5-56t47.5-50q5-67-20.5-138T480-775q-1-1 0 0-40 75-65 145t-20 138Zm118 170q12 38 21 76.5t14 87.5q47-17 93-45.5t83.5-74.5q37.5-46 63-111T819-542q0-2 0 0-106 17-187 75.5T513-322Z"
		/>
	</svg>
);
